import { render, staticRenderFns } from "./salesReturnReceivingTemplate.vue?vue&type=template&id=2d425a8d&scoped=true"
import script from "./salesReturnReceivingTemplate.vue?vue&type=script&lang=js"
export * from "./salesReturnReceivingTemplate.vue?vue&type=script&lang=js"
import style0 from "./salesReturnReceivingTemplate.vue?vue&type=style&index=0&id=2d425a8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d425a8d",
  null
  
)

export default component.exports